import { combineReducers } from 'redux';

import paperworkVerifyDob from './requests/paperwork-verify-dob';
import paperworkAppointmentDetails from './requests/paperwork-get-appointment-details';
import paperworkUserDetails from './requests/paperwork-get-user-details';
import paperworkSubmitAppointment from './requests/paperwork-submit-appointment';
import paperworkAppointmentSession from './requests/paperwork-appointment-session';
import paperworkAdditionalInfo from './requests/paperwork-get-additional-info';
import common from './reducers/common';

export default combineReducers({
  common,
  paperworkAdditionalInfo,
  paperworkAppointmentDetails,
  paperworkAppointmentSession,
  paperworkSubmitAppointment,
  paperworkUserDetails,
  paperworkVerifyDob,
});



// WEBPACK FOOTER //
// ./src/redux/paperwork/index.js